Apt.fn.make('account.hidden', {
	/**
	 * Initialize module
	 */
	init() {
		const app = 'hidden';

		let events;

		this.index = Apt.fn.index().init({
			app: app,
			auth: true,
			view: $$('template')[0].textContent,
			path: 'account/hidden',
			resource: 'me/hidden',
			paginate: true,
			sorting: {
				'-newest': 'Newest',
				'-price': 'Price: high to low',
				'price': 'Price: low to high',
				'-size': 'Size: large to small',
				'size': 'Size: small to large',
				'-updated': 'Updated'
			},
			params: {
				limit: 18
			},
			transform: Apt.properties.transform,
			model: {
				empty: 'You don\'t have any current hidden properties.',
				label: 'property',
				standalone: true
			},
			updated: (data, init) => {
				if (! init) {
					events.update();
				}
			},
			unload: () => {
				if (events) {
					events.unload();
				}
			},
			destroy: () => {
				if (events) {
					events.$destroy();
				}
			}
		}, () => {
			events = Apt.fn['properties.events']()
				.init({
					app: app,
					delegate: '$results'
				});
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.destroy(this, 'index');
	}
});